import * as Sentry from '@sentry/react';
import {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router';
import {selectUserIsAuthorizedFlag} from '~/entities/user';
import {usePublicHttpClient} from '~/library/network-facade';
import appActions from '~/redux/appActions';
import appLoadTimeStatistic from '~/shared/api/legacy_services/appLoadTimeStatistic';
import {appSessionStorage} from '~/shared/persistence';

export function AppEffects(): null {
    useScrollToTopEffect();
    useAppLoadStatisticEffect();
    useAppFistMountEffect();
    useUserIdentityForSentry();
    return null;
}

function useAppFistMountEffect() {
    const dispatch = useDispatch();
    const ran = useRef(false);
    useEffect(() => {
        if (!ran.current) ran.current = true;
        dispatch(appActions.refreshData('init'));
    }, [dispatch]);
}

function useAppLoadStatisticEffect() {
    const http = usePublicHttpClient();
    useEffect(() => {
        appLoadTimeStatistic.onAppMounted(http);
    }, []);
}

function useScrollToTopEffect() {
    const {pathname} = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
}

function useUserIdentityForSentry() {
    const isAuthorized = useSelector(selectUserIsAuthorizedFlag);
    useEffect(() => {
        const userId = appSessionStorage.userId.get();
        if (isAuthorized && userId) {
            Sentry.setUser({id: userId});
        } else {
            Sentry.setUser(null);
        }
    }, [isAuthorized]);
}
